import {
  CashRegisterStateEnum,
  IRegisterWithOwner,
  ShiftStateEnum,
} from "@prostocheck/shared";

export const TEST_REGISTERS: IRegisterWithOwner[] = [
  {
    fiscalNumber: "4001280800",
    name: "Магазин на Хрещатику",
    address: "м. Київ, вул. Хрещатик, 22",
    state: CashRegisterStateEnum.Active,
    shiftState: ShiftStateEnum.Closed,
    taxNumber: "3012345678",
    organisationName: "ФОП Коваленко Олена Ігорівна",
    businessUnitName: "Магазин на Хрещатику",
    taxObjectId: "guid",
    localNumber: 1,
  },
];
